// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1xOnR","location":"Header_location__1f3A_"};